module.exports = __webpack_public_path__ + "static/img/HAMBURG-OAK.5fbc8f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HAMBURG-OAK.png
// module id = XcsA
// module chunks = 0